import { memo } from 'react';
import { Alert, Box, Button, Modal, SpaceBetween } from '@amzn/awsui-components-core';
import { ContentNode } from '@amzn/awscat-pattern-library-service-model';

import {
  NODE_SHORT_TITLE_MAX_LENGTH,
  NODE_SHORT_TITLE_MIN_LENGTH,
  SECTION_TITLE_MAX_LENGTH,
  SECTION_TITLE_MIN_LENGTH,
} from '../v2-common/InlineValidations';
import TitleInput from '../v2-common/TitleInput';
import { useEditSectionButtonViewModel } from './EditSectionButtonViewModel';

interface EditSectionButtonProps {
  readonly currentPage: ContentNode;
  readonly currentSection: ContentNode;
}

const EditSectionButton = memo(function EditSectionButton({
  currentPage,
  currentSection,
}: EditSectionButtonProps) {
  const vm = useEditSectionButtonViewModel(currentPage, currentSection);

  return (
    <>
      <Button
        variant="icon"
        iconName="edit"
        ariaLabel="Edit section title"
        onClick={vm.openModal}
      />
      {vm.isModalVisible && (
        <Modal
          visible
          header="Edit Section Title"
          onDismiss={vm.dismissModal}
          footer={
            <Box float="right">
              <SpaceBetween direction="horizontal" size="xs">
                <Button variant="link" onClick={vm.dismissModal}>
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  disabled={!vm.isSaveEnabled}
                  loading={vm.isSaving}
                  onClick={vm.confirmSave}
                >
                  Save
                </Button>
              </SpaceBetween>
            </Box>
          }
        >
          <SpaceBetween direction="vertical" size="s">
            <TitleInput
              label="Section title"
              initialTitle={vm.title}
              minLength={SECTION_TITLE_MIN_LENGTH}
              maxLength={SECTION_TITLE_MAX_LENGTH}
              onTitleChanged={vm.updateTitle}
              autoFocus
            />
            <TitleInput
              label={
                <>
                  Short title - <i>optional</i>
                </>
              }
              initialTitle={vm.shortTitle}
              minLength={NODE_SHORT_TITLE_MIN_LENGTH}
              maxLength={NODE_SHORT_TITLE_MAX_LENGTH}
              onTitleChanged={vm.updateShortTitle}
            />
            {vm.saveErrorMessage !== undefined && <Alert type="error">{vm.saveErrorMessage}</Alert>}
          </SpaceBetween>
        </Modal>
      )}
    </>
  );
});

export default EditSectionButton;
